<template>
  <form id="forgot-password" class="std-form">
    <router-link class="close-button" to="/"></router-link>
    <h2>Forgot password?</h2>
    <div class="form-group">
      <label for="user-email">Enter your email address</label>
      <input v-model="email" type="email" id="user-email" />
      <transition name="fade">
        <span class="error-message" v-if="wrongEmail">
          That's not the email address we have for your account. Try Again?
        </span>
      </transition>
    </div>
    <button
      @click.stop.prevent="verifyEmailLocal"
      type="submit"
      class="btn btn-secondary"
    >
      Submit
    </button>
  </form>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      email: ""
    };
  },
  computed: {
    ...mapGetters("forgotPassword", {
      wrongEmail: "getWrongEmail",
      userId: "getUserId"
    })
  },
  methods: {
    ...mapMutations("forgotPassword", {
      setWrongEmail: "setWrongEmail"
    }),
    ...mapActions("forgotPassword", {
      verifyEmail: "verifyEmail"
    }),
    verifyEmailLocal() {
      if (/^[\w\-.+]+@[a-zA-Z0-9.-]+\.[a-zA-z0-9]{2,4}$/.test(this.email)) {
        this.verifyEmail(this.email);
        return;
      }
      this.setWrongEmail(true);
    }
  },
  watch: {
    userId(value) {
      if (value !== 0) {
        this.$router.push("/forgot_questions");
      }
    }
  }
};
</script>

<style scoped>
/* CSS HERE */
#forgot-password {
  position: relative;
  padding-top: 20px;
}
#forgot-password a.close-button {
  margin: 0 0 20px 0;
  position: absolute;
  right: 20px;
  top: -10px;
}
</style>
